import React from "react";
import "./TopMenu.css";
import { StarIcon } from "./HomeIcons";

const TopMenu = ({
  points,
  gameName,
  onBack,
  showBackButton = false,
  displayName,
  onEditDisplayName,
  language,
  onChangeLanguage,
  musicPlaying,
  onToggleMusic,
  onHowToPlay,
}) => {
  return (
    <div className="top-menu">
      <div className="top-menu-content">
        <div className="top-menu-left">
          {showBackButton && (
            <button className="back-button" onClick={onBack} aria-label="Back">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M14 6 L8 12 L14 18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
          {displayName && (
            <button className="display-name-button" onClick={onEditDisplayName}>
              <span className="display-name">{displayName}</span>
              <span className="edit-icon" aria-hidden="true">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4 20 L4 16 L16 4 L20 8 L8 20 L4 20 Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </button>
          )}
        </div>

        <div className="top-menu-center">
          {gameName && <h2 className="current-game-name">{gameName}</h2>}
        </div>

        <div className="top-menu-right">
          {onHowToPlay && (
            <button
              type="button"
              className="howto-menu-button"
              onClick={onHowToPlay}
              aria-label="How to play"
              title="How to play"
            >
              ?
            </button>
          )}
          <button
            className={`music-toggle ${musicPlaying ? "music-on" : "music-off"}`}
            onClick={onToggleMusic}
            aria-label={musicPlaying ? "Turn music off" : "Turn music on"}
            title={musicPlaying ? "Mute music" : "Play music"}
          >
            ♪
          </button>
          <button
            className="language-button"
            onClick={() => onChangeLanguage(language === "en" ? "de" : "en")}
            aria-label="Toggle language"
          >
            {language === "en" ? "EN" : "DE"}
          </button>
          <div className="points-display">
            <span className="points-icon">
              <StarIcon size={16} solid />
            </span>
            <span className="points-value">{points}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopMenu;
